module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-collector-5.b4201059.svg";